<div class="remark-title">
  <h2>{{ 'remark.title' | translate }}</h2>
</div>
<owl-carousel-o [options]="customOptions" class="remark-cards">
  @for (card of data; track $index) {
    <ng-container style="height: 25em">
      <ng-template carouselSlide>
        <div
          class="remark-card"
          [ngStyle]="{ background: card.mouseOn ? '#428FF3' : '#ffffff' }"
          (mouseover)="card.mouseOn = true"
          (mouseout)="card.mouseOn = false">
          <div class="user">
            <div class="name">
              <h6 [ngStyle]="{ color: card.mouseOn ? '#ffffff' : '#7E8184' }">
                {{ card?.['name' + languageSelected] ?? card['nameEn'] }}
              </h6>
            </div>

            <div class="note">
              @for (number of [].constructor(5); track $index) {
                <span>
                  @if (card.note >= $index + 1) {
                    <img src="assets/images/svg/star.svg" alt="star" />
                  } @else {
                    <img src="assets/images/svg/star-clear.svg" alt="star" />
                  }
                </span>
              }
            </div>
          </div>

          <div class="com">
            <p [ngStyle]="{ color: card.mouseOn ? '#ffffff' : '#7E8184' }">
              {{
                card?.['com' + languageSelected] ?? card['comEn']
                  | truncate: truncateValue
              }}
            </p>
          </div>
        </div>
      </ng-template>
    </ng-container>
  }
</owl-carousel-o>
